import React, { useEffect, useRef, useState } from 'react';

const MathPopGame = () => {
  const gameAreaRef = useRef(null);
  const correctSound = useRef(new Audio("https://cdn.pixabay.com/download/audio/2022/02/23/audio_b5b2bcd7a8.mp3"));
  const wrongSound = useRef(new Audio("https://cdn.pixabay.com/download/audio/2022/03/09/audio_d0f93fc268.mp3"));

  const [score, setScore] = useState(0);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState(null);
  const [balloons, setBalloons] = useState([]);

  useEffect(() => {
    const loop = setInterval(() => {
      generateRound();
    }, 4500);

    generateRound();
    return () => clearInterval(loop);
  }, []);

  const getRandomInt = (min, max) =>
    Math.floor(Math.random() * (max - min + 1)) + min;

  const generateExpression = () => {
    let a = getRandomInt(1, 9);
    let b = getRandomInt(1, 9);
    const op = Math.random() < 0.5 ? '+' : '-';
    if (op === '-' && b > a) [a, b] = [b, a];
    const expression = `${a} ${op} ${b}`;
    return { expression, result: eval(expression) };
  };

  const generateRound = () => {
    const { expression, result } = generateExpression();
    setQuestion(expression);
    setAnswer(result);

    const choices = new Set([result]);
    while (choices.size < 4) {
      choices.add(getRandomInt(1, 18));
    }

    const shuffled = [...choices].sort(() => Math.random() - 0.5);
    setBalloons(shuffled.map((val, i) => ({
      id: `${Date.now()}-${i}`,
      value: val,
      popped: false,
    })));
  };

  const handleBalloonClick = (balloonId, value) => {
    setBalloons(prev =>
      prev.map(b => {
        if (b.id === balloonId && !b.popped) {
          if (value === answer) {
            correctSound.current.currentTime = 0;
            correctSound.current.play();
            setScore(s => s + 1);
            return { ...b, popped: true, pop: true };
          } else {
            wrongSound.current.currentTime = 0;
            wrongSound.current.play();
            return { ...b, shake: true };
          }
        }
        return b;
      })
    );
  };

  const handleAnimationEnd = (balloonId) => {
    setBalloons(prev => prev.filter(b => b.id !== balloonId));
  };

  return (
    <div ref={gameAreaRef} style={styles.gameArea}>
      <div style={{ ...styles.overlayBox, left: 20 }}>Score: {score}</div>
      <div style={{
        ...styles.overlayBox,
        left: '50%',
        transform: 'translateX(-50%)'
      }}>
        Question: {question}
      </div>

      {balloons.map((balloon, index) => (
        <div
          key={balloon.id}
          className={`balloon ${balloon.popped ? 'pop' : ''} ${balloon.shake ? 'shake' : ''}`}
          style={{
            left: `${index * 25 + 10}%`,
            bottom: '-150px',
            animation: balloon.popped ? 'pop 0.4s ease-out forwards' : 'float 4.5s linear forwards',
          }}
          onClick={() => handleBalloonClick(balloon.id, balloon.value)}
          onAnimationEnd={() => handleAnimationEnd(balloon.id)}
        >
          {balloon.value}
        </div>
      ))}

      <style>{`
        @keyframes float {
          0% { bottom: -150px; opacity: 1; }
          100% { bottom: 110%; opacity: 0; }
        }

        @keyframes pop {
          0% { transform: scale(1); opacity: 1; }
          100% { transform: scale(1.5); opacity: 0; }
        }

        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          50% { transform: translateX(5px); }
          75% { transform: translateX(-5px); }
        }

        .balloon {
          position: absolute;
          width: 80px;
          height: 100px;
          background: #f48fb1;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 24px;
          font-weight: bold;
          color: #fff;
          box-shadow: 0 4px 10px rgba(0,0,0,0.3);
          cursor: pointer;
        }

        .balloon.pop {
          animation: pop 0.4s ease-out forwards !important;
        }

        .balloon.shake {
          animation: shake 0.4s;
        }
      `}</style>
    </div>
  );
};

const styles = {
  gameArea: {
    position: 'relative',
    width: '100vw',
    height: '100vh',
    overflow: 'hidden',
    background: 'linear-gradient(to top, #a0e9ff, #ffffff)',
    fontFamily: 'Comic Sans MS, cursive, sans-serif'
  },
  overlayBox: {
    position: 'absolute',
    top: '15px',
    backgroundColor: 'rgba(255,255,255,0.85)',
    padding: '10px 20px',
    borderRadius: '10px',
    fontSize: '22px',
    fontWeight: 'bold',
    color: '#333',
    boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
    zIndex: 2
  }
};

export default MathPopGame;
